<template>
    <v-dialog v-model="mostrar" fullscreen>
        <v-card class="mx-auto" light>
            
            <relacionarOficioTab
                @tipoOficioSeleccionado="tipoOficioSeleccionado"
            />
            <v-card-title
            >
                <v-btn 
                    color="blue-grey" 
                    icon
                    dark
                    large
                    @click="$emit('cancelar')"
                    >
                    <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
                
                <v-card-title>
                Oficios {{ this.tipoOficio+'s' }} disponibles
                </v-card-title>
                <div class="flex-grow-1"></div>
                
                <v-text-field
                v-model="search"
                append-icon="fa-search"
                label="Buscar"
                single-line
                hide-details
                clearable
                @change="buscarOficio()"
            ></v-text-field>


            </v-card-title>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="officios"
                    locale="es-mx"
                    hide-default-footer
                >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="item in items" :key="item.name">
                            <td>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn 
                                            color="blue-grey" 
                                            x-small dark v-on="on"
                                            :disabled="item.relacionado.id ? true : false"
                                            @click="relacionar(item._id, item.tipoOficio)"
                                        >
                                            <v-icon small>mdi-reply-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Asignar como respuesta</span>
                                </v-tooltip>
                           
                                <v-tooltip v-if="item.relacionado.id" right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on">mdi-reply-outline</v-icon>
                                    </template>
                                    <span>Oficio de respuesta</span>
                                </v-tooltip>
                            </td>
                            <td v-html = "item.numero"></td>
                            <td>{{item.status}}</td>
                            <td>{{formatoFecha(item.fecha)}}</td>
                            <td>{{formatoFecha(item.recepcion)}}</td>
                            <td><p v-html="(item.destinatario)"></p></td>
                            <td v-html = "item.asunto"></td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </v-card-text>
            <section class="d-flex justify-center align-center flex-column">
      
                <div class="d-flex">
                    <v-pagination v-model="page" @input="cargarOficios" :length="totalPages || 1" :total-visible="6"
                    class="mr-2" color="blue-grey"></v-pagination>
                    <v-select style="max-width: 175px;" @input="cargarOficios" :value="`Página ${page}`"
                    :menu-props="{ top: true, offsetY: true }" :items="Array.from({ length: totalPages || 1 }, (_, i) => `Página ${i + 1}`)"
                    hide-details outlined dense></v-select>
                </div>
                <span class="grey--text text-center">Mostrando {{ (page != totalPages && page < totalPages) ? page * 10 :
                    totalOficios }} de {{ totalOficios }} oficios. </span>
                </section>
            <!-- <paginacion
                :page="page"
                :pages="pages"
                :totalDatos="totalOficios"
                :perPage="perPage"
                :cantPage="cantPage"
                @paginaAnt="paginaAnt"
                @paginaSig="paginaSig"
                @cambiarPag="cambiarPag"
            /> -->

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small outlined @click="$emit('cancelar')">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapGetters } from "vuex";
import {DateTime} from 'luxon';

import { cargarOficiosEntrantesService } from "./oficiosEntrantes.service";
import { cargarOficiosGeneradosService } from "./oficiosGenerados.service";

import RelacionarOficioTab from "./relacionarOficios.view.vue";
import Paginacion from "../MainTemplate/paginacion/paginacion.vue";


export default {
    props:['mostrar','idPadre','tipoPadre','historicoId'],
    computed:{
        ...mapGetters([
            "httpURL", 
            "sessionToken",
            "userId"
        ]),
        
    },
    components: {
        Paginacion,
        RelacionarOficioTab,
    },
    data: () => ({
        loading: false,
        search: "",
        agregarEntrante: false,
        agregarGenerado: false,
        headers: [
            { text: '', value: 'options', sortable: false },

            { text: 'Número', value: '' },
            { text: 'Status', value: 'status' },
            { text: 'Fecha', value: 'fecha' },
            { text: 'Recepción', value: 'recepcion' },
            { text: 'Para', value: 'para' },
            { text: 'Asunto', value: 'asunto' },
        ],
        oficios: [],
        tipoOficio: 'entrante',
        ultimaEntidad: null,
        page: 1,
        pages: 1,
        totalOficios: 1,
        perPage: 1,
        cantPage: 1,
        auxPage: 1,
        totalPages: 1,
        officios:[]

    }),
    created(){
        this.cargarOficios();
    },
    methods: {
        formatoFecha(fecha){
            return fecha ? DateTime.fromISO(fecha).toFormat('dd/MM/yyyy') : 'Sin capturar';
        },
        formatoFechaHora(fecha) {
            if(fecha){
            let dateTime = DateTime.fromFormat(fecha, "yyyy-MM-dd T");
            if(!dateTime.isValid) dateTime = DateTime.fromFormat(fecha, "yyyy-MM-dd TT");
            return dateTime.toFormat('dd/MM/yyyy')
            }
            else return 'Sin capturar'
        },
        relacionar(id,tipo){
            axios.post(this.httpURL+'/oficios/relacionar/'+this.tipoPadre+'/'+this.idPadre+'/'+tipo+'/'+id, {},
                {headers:{token:this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        this.$emit('oficioRelacionado',res.data.historico);
                        this.$emit('nuevoLog')
                    }else{
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
        },
        async cargarOficios () {
            try {
                this.loading = true;
                if (!this.search || this.search.trim()==="") {
                    const serverResponse = this.tipoOficio == "entrante" 
                    ? await cargarOficiosEntrantesService(this.page, '',0,false)
                    : await cargarOficiosGeneradosService(this.page, '',0,false);
                    this.loading = false;
                    this.oficios = serverResponse.oficios;
                    this.pages = serverResponse.pages;
                    this.totalOficios = serverResponse.totalOficios;
                    this.totalPages = serverResponse.paginas;

                    if(this.oficios.length){
                        this.noMostrarOficios();
                        this.oficiosList()
                    }
                    this.contadorPaginas();
                } else {
                    const serverResponse = this.tipoOficio == "entrante" 
                    ? await cargarOficiosEntrantesService(this.page, this.search.trim(), 0, false)
                    : await cargarOficiosGeneradosService(this.page, this.search.trim(), 0, false);

                    this.loading = false;
                    this.oficios = serverResponse.oficios;
                    this.pages = serverResponse.pages;
                    this.totalOficios = serverResponse.totalOficios;
                    this.totalPages = serverResponse.paginas;
                    this.noMostrarOficios();
                    this.contadorPaginas();
                    this.oficiosList()
                }
                
            } catch (error) {
                this.loading = false;
                this.$notificarError(error.message);
            }
        },
        contadorPaginas(){
            this.perPage = this.page * 10;
            if (this.totalOficios < this.perPage) {
                this.cantPage = this.perPage - 9;   
                this.perPage = this.totalOficios;  
                this.auxPage = this.perPage - this.cantPage; 
                this.cantPage = this.perPage - this.auxPage; 
            } else {
                this.cantPage = this.perPage - 9;
            }
        },
        paginaSig(){
            this.page++;
            this.cargarOficios();
        },
        paginaAnt(){
            this.page--;
            this.cargarOficios();
        },
        cambiarPag(pagina){
            this.page = pagina;
            this.cargarOficios();
        },
        buscarOficio(){
            this.page = 1;
            this.cargarOficios();
        },
        tipoOficioSeleccionado(data) {
            this.tipoOficio = data;
            this.page=1
            this.cargarOficios();
        },
        noMostrarOficios() {

            for (let i = 0; i < this.historicoId.length; i++) {
                let index = this.oficios.findIndex((x) => x._id == this.historicoId[i]);
                    if(index != -1){
                        this.oficios.splice(index,1);
                        this.totalOficios=this.totalOficios-1;
                    }
            }
    
        },
        oficiosList(){
            this.officios=[]
            if(this.oficios.length){
                this.oficios.forEach(x=>{
                    let obj = {
                        _id:x._id,
                        relacionado:x.relacionado,
                        tipoOficio:this.tipoOficio,
                        numero:this.tipoOficio=='entrante'?x.numero:x.numeroCompleto,
                        status:x.status,
                        fecha:x.fecha,
                        recepcion:this.tipoOficio=='entrante'?this.formato(x.recepcion):x.fechaRecibido!=null?this.formato(x.fechaRecibido):'',
                        destinatario: this.tipoOficio=='entrante'?`${x.destinatario.usuario.nombreCompleto}`:x.destinatario.responsable,
                        asunto:x.asunto

                    }
                    this.officios.push(obj)
                })
            }
     
        },
        formato(fecha){
            let f = fecha.split(' ')
            return f[0]
       }
    }
}

</script>
